import Navbar from "./Navbar";
import Footer from "./Footer";
import VerifyEmailBanner from "./VerifyEmailBanner";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-p2w-bg text-white">
            <Navbar />
            <VerifyEmailBanner />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}
